import React from 'react';
import Portal from '../../../../../../UI/Portal/Portal';
import { Link } from 'react-router-dom';
import { SharedCatalogEntryList } from '../../../../../Shared/Content/Layouts/Widgets/CatalogEntryList/CatalogEntryList';
import CatalogEntryListTile from './CatalogEntryListTile';
import { CatalogEntryListStyleHeight } from '../../../../../Shared/Content/Layouts/Widgets/CatalogEntryList/CatalogEntryListStyleHeight';
import withFacet from '../../../../../../Hooks/Shared/Facet/withFacet';
import useFacet from '../../../../../../Hooks/Shared/Facet/useFacet';
import useAuthenticated from '../../../../../../Hooks/useAuthenticated';
import './CatalogEntryList.scss';

class CatalogEntryList extends SharedCatalogEntryList {
  constructor(props) {
    super(props);
    this.state.sortOpen = false;
  }

  async componentDidMount() {
    if (this.criteoCallData && typeof this.criteoCallData === 'object') {
      this.fetchCriteoAdData(
        this.criteoCallData.searchTerms,
        this.criteoCallData.subCategory,
        this.criteoCallData.distinctPIDs,
        this.criteoCallData.criteoFacets
      );
      this.criteoCallData = '';
    }
    await this.props.passedAppFunctions.updateStateWithCookies();
  }

  componentDidUpdate() {
    try {
      setTimeout(() => zonos.displayCurrency(), 400);
    } catch {
      console.log('zonos error in catalogEntryList');
    }
  }

  render() {
    return (
      <div className='CatalogEntryList col p-0'>
        <script
          type='application/ld+json'
          id='resultList'
          suppressHydrationWarning={true}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(this.buildStructuredDataForProductList()),
          }}
        ></script>

        <CatalogEntryListStyleHeight passedAppFunctions={this.props.passedAppFunctions} />
        {/* <If test={this.props.passedAppFunctions.siteFormat == 'tablet'}>
          <div id='selectFilterFacets' className="mx-0 my-0" >
            <If test={this.props.selectedFacets.length > 0}>
              <span>
                <Link rel='nofollow' className='clearAllFilters p-0 m-0' to={this.props.generateLinkForFacet(false)} onClick={this.resetKeepPos}>
                  clear all
                </Link>
              </span>
              <ForEach var='thisFacetValue' items={this.props.selectedFacets}>
                <If test={this.props.getFacetNameFromFacetValue(thisFacetValue) != 'facet'}>
                  <span className='selectedFilter' key={thisFacetValue}>
                    <Link rel='nofollow' to={this.props.generateLinkForFacet(thisFacetValue)} onClick={this.resetKeepPos}>
                      {this.props.getFacetNameFromFacetValue(thisFacetValue)
                        .split('#double;')
                        .join('"')}
                      <svg
                        role='img'
                        aria-labelledby={
                          'clearFilter' +
                          this.props.getFacetNameFromFacetValue(thisFacetValue)
                            .split('#double;')
                            .join('"')
                            .split(' ')
                            .join('')
                        }
                        height='10'
                        width='10'
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 48.77 48.77'>
                        <title
                          id={
                            'clearFilter' +
                            this.props.getFacetNameFromFacetValue(thisFacetValue)
                              .split('#double;')
                              .join('"')
                              .split(' ')
                              .join('')
                          }>
                          clear filter
                        </title>
                        <g data-name='Layer 2'>
                          <g data-name='Layer 1'>
                            <path d='M25.8,24.39,48.48,1.71A1,1,0,0,0,47.07.29L24.39,23,1.71.29A1,1,0,0,0,.29,1.71L23,24.39.29,47.07a1,1,0,1,0,1.41,1.41L24.39,25.8,47.07,48.48a1,1,0,0,0,1.41-1.41Z' />
                          </g>
                        </g>
                      </svg>
                    </Link>
                  </span>
                </If>
              </ForEach>
            </If>
          </div>
        </If> */}

        <div className='d-flex w-100 p-0 container-fluid'>
          {this.props.passedAppFunctions.siteFormat == 'desktop' &&
          this.props.passedAppFunctions.getURLParamValue('justForYou') != '1' ? (
            <div className='col-5 sortBy'>
              <label htmlFor='catalog-entry-list-sort'>Sort By </label>
              <select
                id='catalog-entry-list-sort'
                onChange={this.updateOrderBy}
                value={
                  (this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                    this.props.passedAppFunctions.wasParms.defaultNavSort) == '1' &&
                  (this.props.passedAppFunctions.getURLParamValue('emphasize') || '').indexOf('$') == 0
                    ? '0'
                    : this.props.passedAppFunctions.getURLParamValue('orderBy') || '1'
                }
              >
                <option value='1'>Popular Items</option>
                {this.props.passedAppFunctions.generatePersonalizationParam() &&
                this.props.passedAppFunctions.isPersonalizationOn() &&
                this.props.passedAppFunctions.navState.indexOf('search-term') == -1 ? (
                  <option value='0'>Just For You</option>
                ) : null}
                {this.props.passedAppFunctions.navState.indexOf('/c/sale-clearance') > -1 ||
                this.props.passedAppFunctions.navState.indexOf('/c/clearance-') > -1 ? (
                  <>
                    <option value='7'>Price Low To High</option>
                    <option value='8'>Price High To Low</option>
                  </>
                ) : (
                  <>
                    <option value='3'>Price Low To High</option>
                    <option value='4'>Price High To Low</option>
                  </>
                )}
                <option value='5'>Top Rated</option>
                <option value='6'>Newest</option>
                {this.props.passedAppFunctions.navState.indexOf('/c/sale-clearance') == -1 &&
                  this.props.passedAppFunctions.navState.indexOf('/c/clearance-') == -1 && (
                    <option value='9'>Sale</option>
                  )}
              </select>
            </div>
          ) : (
            <TabletSort
              selectedFacets={this.props.selectedFacets}
              generateLinkForFacet={this.props.generateLinkForFacet}
              getFacetNameFromFacetValue={this.props.getFacetNameFromFacetValue}
              toggleFacetMenu={this.props.toggleFacetMenu}
              toggleSortMenu={this.props.toggleSortMenu}
              passedAppFunctions={this.props.passedAppFunctions}
              updateOrderBy={this.updateOrderBy}
            />
          )}

          <div
            className='col-7 col-md-6 col-xl-7 p-r-0 pagination__wrapper d-flex align-items-center justify-content-end row-fluid'
            id='topPagination'
          >
            {!this.props.customJustForYouChecked && (
              <Pagination
                {...this.props}
                generatePaginationLink={this.generatePaginationLink}
                customJustForYouChecked={this.props.customJustForYouChecked}
              />
            )}
          </div>
        </div>
        {/* </If> */}
        <div className='row tilesWrapper'>
          <TileArea
            justForYouChecked={this.props.justForYouChecked}
            customJustForYouChecked={this.props.customJustForYouChecked}
            selectedFacets={this.props.selectedFacets}
            generateLinkForFacet={this.props.generateLinkForFacet}
            passedAppFunctions={this.props.passedAppFunctions}
            widgetData={this.props.widgetData}
            actualBreadCrumb={this.props.actualBreadCrumb}
            getProducts={this.state.products}
            criteoBeaconData={this.state.criteoBeaconData}
            sponsoredAdBeacons={this.sponsoredAdBeacons}
          />
        </div>
        <div className='col pagination__wrapper d-flex align-items-center justify-content-end' id='bottomPagination'>
          <Pagination
            {...this.props}
            generatePaginationLink={this.generatePaginationLink}
            currentPage={(this.props.passedAppFunctions.getURLParamValue('pageNumber') || '1') * 1}
          />
        </div>
      </div>
    );
  }
}
function EditMyPreferencesBtn() {
  const isAuthenticated = useAuthenticated();
  return (
    <div id='edit-my-preferences'>
      <a href='/my-preferences' className='btn btn-primary px-4 m-0'>
        {isAuthenticated ? 'Edit My Preferences' : 'Login & Edit My Preferences'}
      </a>
    </div>
  );
}
class TileArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.storedIsInternational = this.props.passedAppFunctions.isInternational();
    this.state.products = this.props.getProducts;
  }

  componentDidUpdate() {
    this.props.sponsoredAdBeacons();
  }
  shouldComponentUpdate(nextProps, nextState) {
    var returnValue = false;
    if (this.props.passedAppFunctions.isInternational() != this.state.storedIsInternational) {
      this.state.storedIsInternational = this.props.passedAppFunctions.isInternational();
      returnValue = true;
    }
    if (nextProps.passedAppFunctions.quickviewIsOpen) {
      return false;
    }
    if (!_.isEqual(this.props.getProducts, nextProps.getProducts)) {
      this.state.products = nextProps.getProducts;
      return true;
    }
    if (nextProps.justForYouChecked != this.props.justForYouChecked) {
      returnValue = true;
    }
    return returnValue || !_.isEqual(this.props.widgetData, nextProps.widgetData);
  }
  resetKeepPos = () => {
    this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
  };

  render() {
    if (this.state.products && this.state.products.length > 0 && !this.props.customJustForYouChecked) {
      return (
        <>
          {this.state.products.map((thisProduct, productIndex) => (
            <CatalogEntryListTile
              lastTile={productIndex == this.state.products.length - 1}
              passedAppFunctions={this.props.passedAppFunctions}
              siteFormat={this.props.passedAppFunctions.siteFormat}
              thisProduct={thisProduct}
              key={productIndex + thisProduct.catentryId}
              productIndex={productIndex}
              actualBreadCrumb={this.props.actualBreadCrumb}
              currentPage={this.props.currentPage}
            />
          ))}
          {
            //placement onload fire
            this.props.criteoBeaconData &&
            typeof this.props.criteoBeaconData === 'object' &&
            this.props.criteoBeaconData.onLoad
              ? this.props.passedAppFunctions.fireXhttpRequestGET(this.props.criteoBeaconData.onLoad)
              : ''
          }
          {
            //placement onload removal
            this.props.criteoBeaconData &&
            typeof this.props.criteoBeaconData === 'object' &&
            this.props.criteoBeaconData.onLoad
              ? (this.props.criteoBeaconData.onLoad = '')
              : ''
          }
        </>
      );
    }

    return (
      <>
        {!this.state.storedIsInternational && this.props.customJustForYouChecked ? (
          <div className='col-sm-12 col-sm-12 col-md-12 col-lg-12'>
            <div id='share-preference' className='message text-center p-4 m-t-15'>
              <h2 id='preference-header' className='mt-2'>
                Just For You
              </h2>
              <p id='preference-message'>
                We&apos;re ready to help you shop! Simply share your style preferences with us, and we will guide you in
                finding items for your interest.
              </p>
              <EditMyPreferencesBtn />
              <div id='preference-no-thanks'>
                <Link
                  rel='nofollow'
                  className='clearAllFilters btn btn-tertiary mb-0'
                  to={this.props.generateLinkForFacet(false)}
                  onClick={this.resetKeepPos}
                >
                  No Thanks
                </Link>
              </div>
            </div>
          </div>
        ) : (
          <div className='col-sm-12 col-sm-12 col-md-12 col-lg-12'>
            <div className='alert alert-danger nav-alert m-t-15 py-3' role='alert'>
              No products were found that match this criteria.
            </div>
          </div>
        )}
      </>
    );
  }
}

class TabletSort extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOpen: false,
      showNotDefault: false,
    };
    this.toggleSort = this.toggleSort.bind(this);
    this.handleFilterClose = this.handleFilterClose.bind(this);
  }

  toggleSort() {
    this.props.toggleSortMenu();
    this.setState({ sortOpen: !this.state.sortOpen });
  }

  handleFilterClose() {
    this.toggleSort();
    this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
    this.props.passedAppFunctions.setNavigationToggle('filterOpen', false);
    this.props.passedAppFunctions.setWindowPosition('windowPosition', 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.classList.remove('filter-open');
  }

  countSelectedFacets() {
    const visibleFacets = this.props.selectedFacets.filter((facet) => facet && facet !== 'facet');
    return visibleFacets.length;
  }

  isCurrentSortBy(sortOptions, text) {
    for (var i = 0; i < sortOptions.length; i++) {
      if (
        (this.props.passedAppFunctions.getURLParamValue('orderBy') ||
          this.props.passedAppFunctions.wasParms.defaultNavSort) == sortOptions[i]
      )
        return true;
    }
    return false;
  }

  resetKeepPos = () => {
    this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
  };

  render() {
    return (
      <React.Fragment>
        <div className='col-5 col-md-6 filter-sort-row'>
          <div className='row'>
            <div className='col p-l-0 p-r-5'>
              <button className='btn btn-secondary btn-filter' type='button' onClick={this.props.toggleFacetMenu}>
                Filter {this.countSelectedFacets() > 0 ? `(${this.countSelectedFacets()})` : ''}
              </button>
            </div>
            <div className='col p-r-0 p-l-5'>
              <button className='btn btn-secondary btn-sort' type='button' onClick={this.toggleSort}>
                {this.isCurrentSortBy(['1'], 'popular') &&
                (this.props.passedAppFunctions.getURLParamValue('emphasize') || '').indexOf('$') != 0 &&
                this.state.showNotDefault
                  ? //Popular Items
                    'Sort: Popular Items'
                  : this.props.passedAppFunctions.isPersonalizationOn() &&
                      this.props.passedAppFunctions.generatePersonalizationParam() &&
                      this.props.passedAppFunctions.navState.indexOf('search-term') == -1 &&
                      this.isCurrentSortBy(['1'], 'fjy') &&
                      (this.props.passedAppFunctions.getURLParamValue('emphasize') || '').indexOf('$') == 0 &&
                      this.state.showNotDefault
                    ? //Just For You
                      'Sort: Just For You'
                    : this.isCurrentSortBy(['3', '7'], 'low to high')
                      ? //Price Low to High
                        'Sort: Price Low To High'
                      : this.isCurrentSortBy(['4', '8'], 'high to low')
                        ? //Price High to Low
                          'Sort: Price High To Low'
                        : this.isCurrentSortBy(['5'], 'top rated')
                          ? //Top Rated
                            'Sort: Top Rated'
                          : this.isCurrentSortBy(['6'], 'newest')
                            ? //Newest
                              'Sort: Newest'
                            : this.props.passedAppFunctions.navState.indexOf('/c/sale-clearance') == -1 &&
                                this.props.passedAppFunctions.navState.indexOf('/c/clearance-') == -1 &&
                                this.isCurrentSortBy(['9'], 'sale')
                              ? //Sale
                                'Sort: Sale'
                              : //Default
                                'Sort'}
              </button>
            </div>
          </div>
        </div>
        <Portal>
          <div className={`SortPortal ${this.state.sortOpen == true ? 'opened' : ''}`}>
            <aside className={`sort-by-wrapper filter-sort-wrappers ${this.state.sortOpen == true ? 'opened' : ''}`}>
              <div className='sort-by-content filter-sort-contents'>
                <div className='header-wrapper'>
                  <button className='btn btn-secondary' type='button' onClick={this.handleFilterClose}>
                    Done
                  </button>
                </div>
                <ul className='sort-list reset-list'>
                  <li
                    className='facet-title'
                    data-value='1'
                    onClick={(e) => {
                      this.props.updateOrderBy(e);
                      this.setState({ showNotDefault: true });
                    }}
                  >
                    Popular Items
                    {this.isCurrentSortBy(['1'], 'popular') &&
                    (this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '1' &&
                    (this.props.passedAppFunctions.getURLParamValue('emphasize') || '').indexOf('$') != 0 ? (
                      <div className='icon i-check-mark'>
                        <span className='sr-only'>Check Mark</span>
                      </div>
                    ) : null}
                  </li>
                  {this.props.passedAppFunctions.isPersonalizationOn() &&
                    this.props.passedAppFunctions.generatePersonalizationParam() && (
                      <li className='facet-title' data-value='0' onClick={this.props.updateOrderBy}>
                        Just For You
                        {(this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                          this.props.passedAppFunctions.wasParms.defaultNavSort) == '1' &&
                          (this.props.passedAppFunctions.getURLParamValue('emphasize') || '').indexOf('$') == 0 && (
                            <div className='icon i-check-mark'>
                              <span className='sr-only'>Check Mark</span>
                            </div>
                          )}
                      </li>
                    )}
                  <li
                    className='facet-title'
                    data-value='3'
                    onClick={(e) => {
                      this.props.updateOrderBy(e);
                      this.setState({ showNotDefault: true });
                    }}
                  >
                    Price Low to High
                    {(this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '3' ||
                    (this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '7' ? (
                      <div className='icon i-check-mark'>
                        <span className='sr-only'>Check Mark</span>
                      </div>
                    ) : null}
                  </li>
                  <li className='facet-title' data-value='4' onClick={this.props.updateOrderBy}>
                    Price High to Low
                    {(this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '4' ||
                    (this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '8' ? (
                      <div className='icon i-check-mark'>
                        <span className='sr-only'>Check Mark</span>
                      </div>
                    ) : null}
                  </li>
                  <li className='facet-title' data-value='5' onClick={this.props.updateOrderBy}>
                    Top Rated
                    {(this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '5' && (
                      <div className='icon i-check-mark'>
                        <span className='sr-only'>Check Mark</span>
                      </div>
                    )}
                  </li>
                  <li className='facet-title' data-value='6' onClick={this.props.updateOrderBy}>
                    Newest
                    {(this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                      this.props.passedAppFunctions.wasParms.defaultNavSort) == '6' ? (
                      <div className='icon i-check-mark'>
                        <span className='sr-only'>Check Mark</span>
                      </div>
                    ) : null}
                  </li>
                  {this.props.passedAppFunctions.navState.indexOf('/c/sale-clearance') == -1 &&
                    this.props.passedAppFunctions.navState.indexOf('/c/clearance-') == -1 && (
                      <li className='facet-title' data-value='9' onClick={this.props.updateOrderBy}>
                        Sale
                        {(this.props.passedAppFunctions.getURLParamValue('orderBy') ||
                          this.props.passedAppFunctions.wasParms.defaultNavSort) == '9' && (
                          <div className='icon i-check-mark'>
                            <span className='sr-only'>Check Mark</span>
                          </div>
                        )}
                      </li>
                    )}
                </ul>
              </div>
            </aside>
            <div className='shade' onClick={this.toggleSort}></div>
          </div>
        </Portal>
      </React.Fragment>
    );
  }
}

class Pagination extends React.Component {
  resetKeepPos = () => {
    this.props.passedAppFunctions.setNavigationToggle('keepPos', false);
  };

  render() {
    var pageSize = (this.props.passedAppFunctions.getURLParamValue('pageSize') || '96') * 1;
    var totalPages = Math.ceil(this.props.widgetData.productCount / pageSize);
    var currentPage = (this.props.passedAppFunctions.getURLParamValue('pageNumber') || 1) * 1;
    if (this.props.customJustForYouChecked) return null;
    return (
      <nav aria-label='Product navigation'>
        <ul className='pagination'>
          <li className='page-item'>
            <span className='itemCount'>{this.props.widgetData.productCount} Items</span>
          </li>
          {totalPages > 1 && (
            <React.Fragment>
              {currentPage !== 1 && (
                <React.Fragment>
                  <li className='page-item' data-value='1'>
                    <Link
                      className='page-link pagination__first'
                      rel={this.props.generatePaginationLink(1).indexOf('facet=') > -1 ? 'nofollow' : undefined}
                      to={this.props.generatePaginationLink(1)}
                    >
                      First
                    </Link>
                  </li>
                  <li className='page-item' data-value={currentPage - 1}>
                    <Link
                      className='page-link'
                      rel={
                        this.props.generatePaginationLink(currentPage - 1).indexOf('facet=') > -1
                          ? 'nofollow'
                          : undefined
                      }
                      to={this.props.generatePaginationLink(currentPage - 1)}
                    >
                      <div className='icon i-arrow-left'>
                        <span className='sr-only'>Previous Page</span>
                      </div>
                    </Link>
                  </li>
                </React.Fragment>
              )}
              {currentPage === totalPages && currentPage > 2 && (
                <li className='page-item' data-value={currentPage - 2}>
                  <Link
                    className='page-link'
                    rel={
                      this.props.generatePaginationLink(currentPage - 2).indexOf('facet=') > -1 ? 'nofollow' : undefined
                    }
                    to={this.props.generatePaginationLink(currentPage - 2)}
                  >
                    {currentPage - 2}
                  </Link>
                </li>
              )}
              {currentPage !== 1 && currentPage - 1 > 0 && (
                <li className='page-item' data-value={currentPage - 1}>
                  <Link
                    className='page-link'
                    rel={
                      this.props.generatePaginationLink(currentPage - 1).indexOf('facet=') > -1 ? 'nofollow' : undefined
                    }
                    to={this.props.generatePaginationLink(currentPage - 1)}
                  >
                    {currentPage - 1}
                  </Link>
                </li>
              )}
              <li className='pagination__activePage page-item' data-value={currentPage}>
                <span>{currentPage}</span>
              </li>
              {currentPage < totalPages && (
                <React.Fragment>
                  <li className='page-item' data-value={currentPage + 1}>
                    <Link
                      className='page-link'
                      onClick={this.resetKeepPos}
                      rel={
                        this.props.generatePaginationLink(currentPage + 1).indexOf('facet=') > -1
                          ? 'nofollow'
                          : undefined
                      }
                      to={this.props.generatePaginationLink(currentPage + 1)}
                    >
                      {currentPage + 1}
                    </Link>
                  </li>
                  {currentPage === 1 && totalPages > 2 && (
                    <li className='page-item' data-value={currentPage + 2}>
                      <Link
                        className='page-link'
                        onClick={this.resetKeepPos}
                        rel={
                          this.props.generatePaginationLink(currentPage + 2).indexOf('facet=') > -1
                            ? 'nofollow'
                            : undefined
                        }
                        to={this.props.generatePaginationLink(currentPage + 2)}
                      >
                        {currentPage + 2}
                      </Link>
                    </li>
                  )}
                  <li className='page-item' data-value={currentPage + 1}>
                    <Link
                      className='page-link'
                      onClick={this.resetKeepPos}
                      rel={
                        this.props.generatePaginationLink(currentPage + 1).indexOf('facet=') > -1
                          ? 'nofollow'
                          : undefined
                      }
                      to={this.props.generatePaginationLink(currentPage + 1)}
                    >
                      <div className='icon i-arrow-right'>
                        <span className='sr-only'>Next Page</span>
                      </div>
                    </Link>
                  </li>
                  <li className='page-item p-r-0' data-value={totalPages}>
                    <Link
                      className='page-link pagination__last'
                      onClick={this.resetKeepPos}
                      rel={
                        this.props.generatePaginationLink(totalPages).indexOf('facet=') > -1 ? 'nofollow' : undefined
                      }
                      to={this.props.generatePaginationLink(totalPages)}
                    >
                      Last
                    </Link>
                  </li>
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </ul>
      </nav>
    );
  }
}

export default withFacet(CatalogEntryList);
